import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { toI18n } from 'util/i18n';

import { ONBOARDING_OPTIONS } from '../AddEmployeeForm/constants';

import { I18N_PATH } from './constants';

interface AddEmployeeModalFooterProps {
  isPayrollEnrolled: boolean;
  isPayrollSetupDone: boolean;
  onboardingOptions: string;
  inviteStatus: string;
  contact: string;
}

const AddEmployeeModalFooter = ({
  isPayrollEnrolled,
  isPayrollSetupDone,
  onboardingOptions,
  inviteStatus,
  contact,
}: AddEmployeeModalFooterProps) => {
  const breakWordStyle = 'word-break: break-all; overflow-wrap: break-word;';
  const wrappedContact = `<span style="${breakWordStyle}">${contact}</span>`;

  return (
    <Box>
      {inviteStatus !== 'not_invited' && !isPayrollEnrolled && (
        // Invite was sent with no onboarding docs or payroll setup
        // This is only an option for non-payroll companies
        <Text
          asHTML
          variant="bodySm"
          i18n={`${I18N_PATH}.invite_sent`}
          i18nProps={{ contact: wrappedContact }}
          textAlign="center"
        />
      )}

      {!(isPayrollEnrolled && !isPayrollSetupDone) &&
        onboardingOptions === ONBOARDING_OPTIONS.INVITE_AND_PACKET && (
          <Text
            variant="bodySm"
            asHTML
            i18n={`${I18N_PATH}.invite_and_onboarding_sent`}
            i18nProps={{ contact: wrappedContact }}
          />
        )}

      {isPayrollEnrolled &&
        !isPayrollSetupDone &&
        (inviteStatus !== 'not_invited' ? (
          // invite was sent
          // include message for both invite and tax details in one line
          <Text
            asHTML
            variant="bodySm"
            i18n={`${I18N_PATH}.invite_sent`}
            i18nProps={{ contact: wrappedContact }}
            textAlign="center"
          >
            {toI18n(`${I18N_PATH}.enter_tax_details`)}
          </Text>
        ) : (
          // invite wasn't sent, only want to include the message for tax details
          <Text variant="bodySm" i18n={`${I18N_PATH}.enter_tax_details`} />
        ))}
    </Box>
  );
};

export default AddEmployeeModalFooter;
